import { useNavigate } from 'react-router';
import Notification from '..';
import { NotificationMetadata, NotificationTimestamp, NotificationTitle } from '../blocks';
import { format } from 'date-fns';

const BidPlacedNotification = ({ notification, handleCloseNotification }) => {
    const navigate = useNavigate();

    return (
        <Notification
            notification={notification}
            onClickHandler={() => {
                navigate(
                    notification.notification_data?.listing_id
                        ? `/listing/${notification.notification_data?.listing_id}`
                        : '/auction/listings'
                );
                handleCloseNotification();
            }}
        >
            <NotificationTitle>New Quote</NotificationTitle>
            <NotificationMetadata>A carrier has placed a quote on your order</NotificationMetadata>
            <NotificationMetadata>Order: {notification.notification_data?.order_number || 'N/A'}</NotificationMetadata>
            <NotificationTimestamp>
                {format(new Date(notification.created_at), 'MMM dd, yyyy @ hh:mm a')}
            </NotificationTimestamp>
        </Notification>
    );
};

export default BidPlacedNotification;
